let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fRZhu")).then(() => parcelRequire('9stOT'));